<template>
  <label class="text-field" :style="{ width: fullWidth ? '100%' : 'auto' }">
    <span class="text-field-label">
      <slot name="label"></slot>
    </span>
    <input
      :type="type"
      class="text-field-input"
      v-bind:value="value"
      v-on:input="$emit('input', $event.target.value)"
      :placeholder="placeholder"
    />
  </label>
</template>

<script>
export default {
  name: "TextField",
  props: {
    type: {
      type: String,
      default: "text"
    },
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.text-field {
  display: flex;
  flex-direction: column;
  margin: 12px 0 8px;
}

.text-field-label {
  margin-bottom: 8px;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
}

.text-field-input {
  outline: none;
  padding: 8px 16px;
  font-size: 12px;
  line-height: 14px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
}

.text-field-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
  line-height: 14px;
}
</style>
